import { render, staticRenderFns } from "./ContractualBillingTab.vue?vue&type=template&id=6864b8b9&"
import script from "./ContractualBillingTab.vue?vue&type=script&lang=js&"
export * from "./ContractualBillingTab.vue?vue&type=script&lang=js&"
import style0 from "./ContractualBillingTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports